import React from 'react';
import { useTranslation } from 'react-i18next';
// import { ExportToExcelBtn } from 'src/screens/Reports/components/ReportsSection/Menu/ActionButtons/ActionButtons';
import { MenuButton, buttonSx } from 'src/screens/Reports/components/ReportsSection/Menu/Menu.style';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import TableChartIcon from '@mui/icons-material/TableChart';
import HTMLTableToExcel from 'src/components/HTMLTableToExcel';
import ExcelDownloaderJs from './ExcelDownloader';

// ExcelDownloader is plain JS (the library has no types); its props, as TypeScript sees them
const ExcelDownloader = ExcelDownloaderJs as unknown as React.ForwardRefExoticComponent<
    { table: string; filename: string } & React.RefAttributes<{ handleDownload: () => void }>
>;

export const blocked = {
    opacity: 0.5,
    pointerEvents: 'none',
} as const;

const defaultStyle = {
    display: 'flex',
    justifyContent: 'left',
    paddingBottom: '5px',
    paddingTop: '0px',
} as const;

interface ExcelExportBtnProps {
    table?: string;
    filename?: string;
    onClick?: Function;
    disabled?: boolean;
}
export const ExportToExcelBtn = (props: ExcelExportBtnProps) => {
    const { onClick, disabled, ...rest } = props;

    return (
        <MenuButton
            startIcon={<TableChartIcon />}
            onClick={(onClick as any) || (() => {})}
            sx={buttonSx}
            disabled={disabled}
        >
            <HTMLTableToExcel {...rest} />
        </MenuButton>
    );
};

export interface Props {
    isSwitchingClient: boolean;
    exports: {
        tableRef: React.MutableRefObject<any>;
        handlePrint: () => void;
        isPrinting: boolean;
    };
    /** Builds the export table, then downloads it (ManualOrder) */
    onExcel: () => void;
    /** Builds the export table, then prints it (ManualOrder) */
    onPrint: () => void;
    /** Set while an export is being prepared */
    isExporting: boolean;
    excelDownloaderRef: React.MutableRefObject<any>;
}

export const MANUAL_ORDERS_EXPORT_TABLE_ID = 'manual-orders-table';
const EXCEL_FILE_NAME = "דו''ח הזמנות שבועי";

const ExportBtns: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    // The style blocks the mouse only; disabled also stops the keyboard
    const isBlocked = props.isSwitchingClient || props.exports.isPrinting || props.isExporting;
    return (
        <div style={isBlocked ? { ...blocked, ...defaultStyle } : { ...defaultStyle }}>
            <MenuButton sx={buttonSx} startIcon={<TableChartIcon />} onClick={props.onExcel} disabled={isBlocked}>
                {`${t('exportTo')} EXCEL`}
            </MenuButton>
            <MenuButton sx={buttonSx} startIcon={<LocalPrintshopIcon />} onClick={props.onPrint} disabled={isBlocked}>
                {t('print')}
            </MenuButton>
            <ExcelDownloader
                ref={props.excelDownloaderRef}
                table={MANUAL_ORDERS_EXPORT_TABLE_ID}
                filename={EXCEL_FILE_NAME}
            />
        </div>
    );
};

export default ExportBtns;
